import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchFaqNotesDocumentsDone = (faqNotesDocuments, { payload }) => {
    return [
        // ...faqNotesDocuments,
        ...payload
    ]
}

  const saveFaqNotesDocumentsDone = (faqNotesDocuments, { payload }) => {
    return [
        ...faqNotesDocuments,
        payload
    ]
  };

  const  updateFaqNotesDocumentsDone = (faqNotesDocuments, { payload }) => {
    return faqNotesDocuments.map( fnd => {
      if(fnd.id === payload.id){
        return payload
      }
      return fnd
    })
  }

  const deleteFaqNotesDocumentsDone = ( faqNotesDocuments, { payload }) => {
    return faqNotesDocuments.filter( fnd => fnd.id !== payload)
  }

  const fetchMaintenanceGuideForAssetByItemIdDone = ( faqNotesDocuments, { payload }) => {    
    return [ ...faqNotesDocuments, ...payload]
  }

  const fetchMaintainanceGuideBySuiteIdDone = ( faqNotesDocuments, { payload }) => {
    return payload;
  }

  const fetchFaqsForAssetByItemIdDone = (faqNotesDocuments, {payload}) => {
    
    // return faqNotesDocuments.map(fnd)
    return [ ...faqNotesDocuments, ...payload]
  }
  const clearFaqsNotesDocumentsDone = () => {
    return []
  }
  const fetchSuiteFaqsDone = (faqNotesDocuments, {payload}) => {
    return [ ...faqNotesDocuments, ...payload];
  }
  const initialState = [];

export default createReducer(initialState, {
    [TYPES.FETCH_FAQS_NOTES_DOCUMENTS_DONE]: fetchFaqNotesDocumentsDone,
    [TYPES.SAVE_FAQ_NOTES_DOCUMENTS_DONE]:saveFaqNotesDocumentsDone,
    [TYPES.UPDATE_FAQ_NOTES_DOCUMENTS_DONE] : updateFaqNotesDocumentsDone,
    [TYPES.DELETE_FAQ_NOTES_DOCUMENTS_DONE] : deleteFaqNotesDocumentsDone,
    [TYPES.FETCH_MAINTENANCE_GUIDE_FOR_ASSET_BY_ITEM_ID_DONE] : fetchMaintenanceGuideForAssetByItemIdDone,
    [TYPES.FETCH_FAQS_FOR_ASSET_BY_ITEM_ID_DONE]: fetchFaqsForAssetByItemIdDone,
    [TYPES.CLEAR_FAQ_NOTES_DOCUMENTS]: clearFaqsNotesDocumentsDone,
    [TYPES.FETCH_MAINTAINANCE_GUIDE_BY_SUITE_ID]:fetchMaintainanceGuideBySuiteIdDone,
    [TYPES.FETCH_SUITE_FAQS_DONE]: fetchSuiteFaqsDone
  });
